export const API_URL = API_URL;
export const headers = { 'Content-Type': 'application/json' };
